export const EMAIL_VALIDATION =
  "[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";

export const NAME_VALIDATION = /^([a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ\'\-\`\ ])*$/;
export const BUILDING_VALIDATION = "[0-9a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ'-/]*";
export const DISTRICT_VALIDATION = "[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ'-/]*";
export const ONLY_NUMBERS_VALIDATION = '[0-9]*';
export const MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 24;
export const ADDRESS_MAX_LENGTH = 30;
export const ZIP_LENGTH = 5;
